export default __webpack_public_path__ + "static/media/news74.b58031f6.jpg";